import PropTypes from 'prop-types';
import { Navigate } from "react-router";
import useAuth from "hooks/useAuth";

const PrivateElement = ({ capabilities, children, redirect = null }) =>
{
   const {
      currentUserCan
   } = useAuth();

   if ( !currentUserCan(capabilities) && !capabilities.includes('all') )
   {
      if( redirect !== null )
      {
         return <Navigate to={redirect} replace />
      }

      return null;
   }

   return children;
}

PrivateElement.propTypes = {
   capabilities: PropTypes.array,
   children: PropTypes.node,
   redirect: PropTypes.string
};

export default PrivateElement;